module.exports = __webpack_public_path__ + "static/media/OneHubLogo.fd5ae6be.png";